const AlarmExecutorList = () => import('Views/alarmExecutor/alarmExecutor-list');
const AlarmExecutorAddEdit = () => import('Views/alarmExecutor/alarmExecutor-addEdit');
const AlarmExecutorDetail = () => import('Views/alarmExecutor/alarmExecutor-detail');

export default[
  { path: '/alarmExecutor-list', component: AlarmExecutorList },
  { path: '/alarmExecutor-add', component: AlarmExecutorAddEdit },
  { path: '/alarmExecutor-edit/:id', component: AlarmExecutorAddEdit },
  { path: '/alarmExecutor-detail/:id', component: AlarmExecutorDetail },
];



// WEBPACK FOOTER //
// ./src/router/alarmExecutor.js